import { render, staticRenderFns } from "./LgameParticipatePopUp.vue?vue&type=template&id=230f46e7&scoped=true"
import script from "./LgameParticipatePopUp.vue?vue&type=script&lang=js"
export * from "./LgameParticipatePopUp.vue?vue&type=script&lang=js"
import style0 from "./LgameParticipatePopUp.vue?vue&type=style&index=0&id=230f46e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230f46e7",
  null
  
)

export default component.exports